import PropTypes from 'prop-types';

// Lib
import { FACEBOOK } from '@/lib/socialProfile';
import { getPostType, FB_POST_TYPES } from '@/lib/posts/postTypes';

// Hooks
import { useTransformStringOnOffset } from '@/utils/hooks/format/useTransformString';
import { AlbumPostIcon } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/AlbumPostIcon';

// Components
import Post from '@/components/base/Post';

const FacebookAlbumPost = ({ data, shouldDisplayIcon }) => {
    const { OffsetReplace, formatFacebookText } = useTransformStringOnOffset();

    const type = getPostType({
        network: FACEBOOK,
        type: data?.type,
        mediasLength: data?.medias?.length
    });

    return (
        <Post data={data} className="w-full">
            <Post.Content className="relative w-full text-left text-sm">
                <AlbumPostIcon
                    show={type !== FB_POST_TYPES.TYPE_PHOTO && shouldDisplayIcon}
                    type={FB_POST_TYPES[type]}
                />

                {(type === FB_POST_TYPES.TYPE_STATUS && data?.caption !== '') ||
                (type === FB_POST_TYPES.TYPE_PHOTO &&
                    data?.medias?.[0]?.type === 'link' &&
                    !data?.medias?.[0]?.image) ? (
                    <Post.Status
                        style="album"
                        withMedia={false}
                        formattedCaption={
                            data?.medias?.[0]?.type === 'link' && data?.caption === '' ? (
                                data?.medias?.[0]?.target ?? ''
                            ) : (
                                <OffsetReplace
                                    text={formatFacebookText(data?.caption, data?.tags, 'span')}
                                    components={{
                                        span: <span className="text-icoBlue" />,
                                        br: <br />,
                                        p: <p />
                                    }}
                                />
                            )
                        }
                    />
                ) : (
                    <div className="square relative">
                        <Post.Image />
                    </div>
                )}
            </Post.Content>
        </Post>
    );
};

FacebookAlbumPost.propTypes = {
    data: PropTypes.object
};

export default FacebookAlbumPost;
